import React from 'react';
import { Link } from 'react-router-dom';
import { mediaUrl } from '../../api/client';

// Single image banner (optionally with heading/button) — used for the promo banners between product rows.
export default function Banner({ section }) {
  const d = section.data || {};
  if (!d.image) return null;
  const pos = (d.position || 'middle-center').split('-');
  const items = { top: 'items-start', middle: 'items-center', bottom: 'items-end' }[pos[0]] || 'items-center';
  const justify = { left: 'justify-start', center: 'justify-center', right: 'justify-end' }[pos[1]] || 'justify-center';
  const inner = (
    <div className="relative">
      <picture>
        {d.mobileImage && <source media="(max-width: 767px)" srcSet={mediaUrl(d.mobileImage)} />}
        <img src={mediaUrl(d.image)} alt={d.heading || d.alt || section.title || ''} className="w-full block" loading="lazy" />
      </picture>
      {(d.heading || d.buttonText || d.text) && (
        <div className={`absolute inset-0 flex ${items} ${justify} p-6 md:p-16`}>
          <div className={`max-w-xl ${pos[1] === 'center' ? 'text-center' : pos[1] === 'right' ? 'text-right' : 'text-left'}`} style={{ color: d.textColor || '#000' }}>
            {d.heading && <h2 className="text-3xl md:text-5xl mb-4" style={{ color: d.textColor || '#000' }}>{d.heading}</h2>}
            {d.text && <div className="mb-5 text-base md:text-lg" dangerouslySetInnerHTML={{ __html: d.text }} />}
            {d.buttonText && <span className="inline-block sf__btn sf__btn-primary">{d.buttonText}</span>}
          </div>
        </div>
      )}
    </div>
  );
  return (
    <section className={`relative home-banner__slideshow eg-banner ${d.fullWidth === false ? 'container-fluid section-my' : ''}`}>
      <div className="w-full">{d.link ? <Link to={d.link} className="block">{inner}</Link> : inner}</div>
    </section>
  );
}
